import { useState } from 'react';
import { Package, Truck, ShoppingCart, GitBranch } from 'lucide-react';
import Suppliers from './compras/Suppliers';
import PurchaseOrders from './compras/PurchaseOrders';
import Materials from './compras/Materials';
import Nodes from './compras/Nodes';

type TabValue = 'suppliers' | 'orders' | 'materials' | 'nodes';

const CARDS = [
  { id: 'suppliers' as TabValue, label: 'Proveïdors', icon: Truck,        color: 'blue' },
  { id: 'materials'as TabValue, label: 'Elements',   icon: Package,       color: 'purple' },
  { id: 'nodes'    as TabValue, label: 'Escandalls', icon: GitBranch,     color: 'amber' },
  { id: 'orders'   as TabValue, label: 'Comandes',   icon: ShoppingCart,  color: 'green' },
];

const COLOR: Record<string, { border: string; bg: string; icon: string; iconBg: string }> = {
  blue:   { border: 'border-blue-500',   bg: 'bg-blue-50/50',   icon: 'text-blue-500',   iconBg: 'bg-blue-500/10' },
  green:  { border: 'border-green-500',  bg: 'bg-green-50/50',  icon: 'text-green-500',  iconBg: 'bg-green-500/10' },
  purple: { border: 'border-purple-500', bg: 'bg-purple-50/50', icon: 'text-purple-500', iconBg: 'bg-purple-500/10' },
  amber:  { border: 'border-amber-500',  bg: 'bg-amber-50/50',  icon: 'text-amber-500',  iconBg: 'bg-amber-500/10' },
};

export default function Compras() {
  const [activeTab, setActiveTab] = useState<TabValue>(() => {
    const saved = localStorage.getItem('compras-activeTab');
    return (saved as TabValue) || 'suppliers';
  });

  const handleTab = (id: TabValue) => {
    setActiveTab(id);
    localStorage.setItem('compras-activeTab', id);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Compres</h1>
        <p className="text-muted-foreground">Gestió de proveïdors, comandes i elements</p>
      </div>

      {/* Stat cards */}
      <div className="grid grid-cols-4 gap-3">
        {CARDS.map(({ id, label, icon: Icon, color }) => {
          const c = COLOR[color];
          const active = activeTab === id;
          return (
            <button
              key={id}
              onClick={() => handleTab(id)}
              className={`flex items-center gap-3 px-4 py-2.5 rounded-xl border transition-all ${
                active ? `${c.border} ${c.bg}` : 'border-border bg-white hover:shadow-sm'
              }`}
            >
              <div className={`p-1.5 rounded-lg shrink-0 ${c.iconBg}`}>
                <Icon className={`h-4 w-4 ${c.icon}`} />
              </div>
              <span className="text-xs font-semibold">{label}</span>
            </button>
          );
        })}
      </div>

      {/* Contingut */}
      <div>
        {activeTab === 'suppliers'  && <Suppliers />}
        {activeTab === 'orders'     && <PurchaseOrders filterPending={false} />}
        {activeTab === 'materials'  && <Materials />}
        {activeTab === 'nodes'      && <Nodes />}
      </div>
    </div>
  );
}
